/**
 * Google Maps Configuration Constants
 * Centralized configuration to prevent loadScript errors
 */

export const GOOGLE_MAPS_API_KEY = 'AIzaSyDTe9cE4XzwFwasKsGQ71h4HVBjm2ZUwCA';

export const GOOGLE_MAPS_LIBRARIES: ('places' | 'geometry' | 'drawing' | 'visualization')[] = ['places'];

export const GOOGLE_MAPS_CONFIG = {
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
};

export const GOOGLE_PLACES_CONFIG = {
  types: ['address'],
  componentRestrictions: { country: 'us' },
  fields: ['address_components', 'formatted_address', 'geometry'],
};
